import { render, staticRenderFns } from "./shareActivity.vue?vue&type=template&id=2088e3fd&scoped=true"
import script from "./shareActivity.vue?vue&type=script&lang=js"
export * from "./shareActivity.vue?vue&type=script&lang=js"
import style0 from "./shareActivity.vue?vue&type=style&index=0&id=2088e3fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2088e3fd",
  null
  
)

export default component.exports